import axios from 'axios';

const state = {
    followUps: [],
    templates: [],
    settings: null,
    stats: null,
    logs: [],
    currentFollowUp: null
};

const getters = {

};

const actions = {
    // Follow Up List
    followup_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('follow-ups', { params: data })
                .then(response => {
                    commit("PUSH_FOLLOW_UPS", response.data.data.follow_ups);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('follow-ups', data)
                .then(response => {
                    commit("PUSH_FOLLOW_UP", response.data.data.follow_up);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_one({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.get(`follow-ups/${id}`)
                .then(response => {
                    commit("PUSH_FOLLOW_UP", response.data.data.follow_up);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            const { id, ...updateData } = data;
            axios.put(`follow-ups/${id}`, updateData)
                .then(response => {
                    commit("PUSH_FOLLOW_UP", response.data.data.follow_up);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.delete(`follow-ups/${id}`)
                .then(response => {
                    commit("REMOVE_FOLLOW_UP", id);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Templates
    followup_template_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('follow-up-templates', { params: data })
                .then(response => {
                    commit("PUSH_TEMPLATES", response.data.data.templates);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_template_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('follow-up-templates', data)
                .then(response => {
                    commit("PUSH_TEMPLATE", response.data.data.template);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_template_one({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.get(`follow-up-templates/${id}`)
                .then(response => {
                    commit("PUSH_TEMPLATE", response.data.data.template);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_template_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            const { id, ...updateData } = data;
            axios.put(`follow-up-templates/${id}`, updateData)
                .then(response => {
                    commit("PUSH_TEMPLATE", response.data.data.template);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_template_delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.delete(`follow-up-templates/${id}`)
                .then(response => {
                    commit("REMOVE_TEMPLATE", id);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Settings
    followup_settings_get({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('follow-up-settings')
                .then(response => {
                    commit("PUSH_SETTINGS", response.data.data.setting);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_settings_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('follow-up-settings', data)
                .then(response => {
                    commit("PUSH_SETTINGS", response.data.data.setting);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Statistics
    followup_stats({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('follow-up-stats', { params: data })
                .then(response => {
                    commit("PUSH_STATS", response.data.data.stats);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Logs
    followup_logs({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('follow-up-logs', { params: data })
                .then(response => {
                    commit("PUSH_LOGS", response.data.data.logs);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Contact History
    followup_contact_history({ commit }, contactId) {
        return new Promise((resolve, reject) => {
            axios.get(`follow-up-contacts/${contactId}/history`)
                .then(response => {
                    commit("PUSH_CONTACT_HISTORY", response.data.data.history);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Pause/Resume/Stop
    followup_contact_pause({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('follow-up-contacts/pause', data)
                .then(response => {
                    commit("PUSH_CONTACT_HISTORY", response.data.data.history);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_contact_resume({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('follow-up-contacts/resume', data)
                .then(response => {
                    commit("PUSH_CONTACT_HISTORY", response.data.data.history);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_contact_stop({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('follow-up-contacts/stop', data)
                .then(response => {
                    commit("PUSH_CONTACT_HISTORY", response.data.data.history);
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_trigger_manual(context, data) {
        return new Promise((resolve, reject) => {
            axios.post('follow-up-contacts/trigger-manual', data)
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    followup_contacts_list(context, data) {
        return new Promise((resolve, reject) => {
            axios.get('follow-up-contacts', { params: data })
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    // Import (bulk)
    followup_import_contacts(context, { id, update_existing, contacts }) {
        return new Promise((resolve, reject) => {
            axios.post(`follow-ups/${id}/import-contacts`, {
                update_existing: !!update_existing,
                contacts: contacts
            })
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
};

const mutations = {
    PUSH_FOLLOW_UPS(state, followUps) {
        state.followUps = followUps;
    },
    PUSH_FOLLOW_UP(state, followUp) {
        state.currentFollowUp = followUp;
    },
    REMOVE_FOLLOW_UP(state, id) {
        state.followUps = state.followUps.filter(followUp => followUp.id !== id);
    },
    PUSH_TEMPLATES(state, templates) {
        state.templates = templates;
    },
    PUSH_TEMPLATE(state, template) {
        const index = state.templates.findIndex(t => t.id === template.id);
        if (index !== -1) {
            state.templates[index] = template;
        } else {
            state.templates.push(template);
        }
    },
    REMOVE_TEMPLATE(state, id) {
        state.templates = state.templates.filter(template => template.id !== id);
    },
    PUSH_SETTINGS(state, settings) {
        state.settings = settings;
    },
    PUSH_STATS(state, stats) {
        state.stats = stats;
    },
    PUSH_LOGS(state, logs) {
        state.logs = logs;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};


